<template lang="pug">
  v-dialog(
    ref="dialog"
    persistent
    width="90vw"
    height="300px"
    max-width="500px"
    v-model="show"
  )
    v-card
      v-card-title.primary
        span.white--text {{$t('sale.import_from_csv')}}
        v-spacer
        v-btn(icon dark @click="close")
          v-icon mdi-close
      v-card-text.mt-2
        v-row.ma-0.pa-0
          v-file-input.pl-0.pt-1.pb-0(
            :label="$t('sale.import_csv_select_file')"
            outlined
            accept="text/csv"
            prepend-icon=""
            prepend-inner-icon="mdi-paperclip"
            dense
            hide-details
            v-model="fileInput"
          )
      v-card-actions
        v-row.ma-0.pa-0(justify="end")
          v-btn.white--text(dark text color="red" @click="close")
            span {{$t('common.cancel')}}
          v-btn(dark text color="#343f4b" @click="handleImport()")
            span {{$t('common.ok')}}
</template>

<script>
import { defineComponent, ref, getCurrentInstance } from 'vue'
import { api } from '@/plugins'
import { endpoints, showError, readFile, FileReadError } from "@/utils"

const UploadFile = defineComponent({
  props: {
    show: {
      type: Boolean,
      required: true
    },
    cstId: {
      type: Number,
      required: true
    },
    auctionDate: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const { $root, $toast } = getCurrentInstance().proxy
    const isUpload = ref(false)
    const refInput = ref(null)
    const fileInput = ref(null)


    const selectFile = () => {
      if (isUpload.value === false) {
        refInput.value.click()
      }
    }

    const close = () => {
      emit('on-close')
    }

    const importCsvAPI = async (body) => {
      try {
        await api.post(`${endpoints.SALE}import_file`, body)
        $toast.success($root.$t('sale.import_successful'))
        emit('import-data-done')
      } catch (e) {
        if (e.response?.data?.detail) {
          const msg = e.response.data.detail.error_code
          showError(e, $toast, $root.$t(`error_code.${msg}`))
        } else {
          showError(e, $toast, $root.$t('sale.import_failed'))
        }
      }
    }
    const handleImport = async () => {
      if (!fileInput.value) {
        $toast.error($root.$t('sale.miss_file'))
        return
      }
      let payload
      try {
        payload = await readFile(fileInput.value)
      } catch (e) {
        if (!(e instanceof FileReadError)) throw e
        $toast.error($root.$t('message.file_read_failed', { name: e.fileName }))
        return
      }
      const body = {
        cst_id: props.cstId,
        auction_date: props.auctionDate,
        file: {
          name: fileInput.value.name,
          type: fileInput.value.type,
          size: fileInput.value.size,
          payload
        }
      }
      await importCsvAPI(body)
      close()
    }

    return {
      isUpload,
      refInput,
      selectFile,
      close,
      handleImport,
      fileInput
    }
  }
})

export default UploadFile
</script>

<style scoped lang="sass">
  .add-new-image
    height: 300px
    border: 1px solid gray
    border-radius: 5px
</style>